import React, { useEffect, useRef } from 'react';
import { useParams } from 'react-router';
import { useDispatch } from 'react-redux';
import { Form } from 'react-final-form';

import GenerateMessagesFormInner from './GenerateMessagesFormInner';
import validate from '../../../../utils/validate';
import { genieGenerationYopValidation } from './validation';
import { ASSISTANTS_CATEGORY, PROJECT_TYPES } from '../../../../constants';
import useTypeOptions from '../../../../hooks/useTypeOptions';

function GenerateMessagesForm({ onGenerateMessages, onReply, onResetSession, onFileUpload, projectType }) {
  const dispatch = useDispatch();
  const { id } = useParams();

  const abortAction = useRef(null);

  const typeOptions = useTypeOptions(
    (state) =>
      state[projectType === PROJECT_TYPES.GENIE_GO ? 'genieGo' : 'genie'].assistants[ASSISTANTS_CATEGORY.GENERATE_ALL],
  );

  const selectedTypeOption = () => {
    const defaultAssistant = typeOptions?.find(({ name }) => name.toLowerCase().includes('default'));
    const firstAssistant = typeOptions[0];

    return defaultAssistant || firstAssistant || null;
  };

  const initialGenerationFormValuesValues = {
    byPass: '',
    focusOn: '',
    url: '',
    docs: null,
    fileText: '',

    channels: {
      [ASSISTANTS_CATEGORY.GENERATE_ALL]: {
        assistant: selectedTypeOption(),
      },
    },
  };

  const handleSubmitGenerationForm = (values) => {
    let resultAction;

    resultAction = dispatch(onGenerateMessages({ id, values }));

    abortAction.current = resultAction?.abort;
  };

  useEffect(() => {
    return () => {
      if (abortAction.current) {
        abortAction.current();
      }
    };
  }, []);

  return (
    <Form
      initialValues={initialGenerationFormValuesValues}
      keepDirtyOnReinitialize
      onSubmit={handleSubmitGenerationForm}
      subscription={{ submitting: true, pristine: true }}
      validate={(values) => validate(values, genieGenerationYopValidation())}
      render={({ handleSubmit }) => (
        <GenerateMessagesFormInner
          onSubmit={handleSubmit}
          onReply={onReply}
          onResetSession={onResetSession}
          onFileUpload={onFileUpload}
          projectType={projectType}
        />
      )}
    />
  );
}

export default GenerateMessagesForm;
